import { createSlice } from '@reduxjs/toolkit';
import { extractHash, extractPathAndQuery } from '../utils/url';
import {
  changeLocation,
  openSidebar,
  closeSidebar,
  setLoadingSidebar,
} from '../actions';
import {
  getAppName,
  getOverlayName,
  isSidebarApp,
  isSidebarHidden,
} from './utils';

export interface CurrentSidebarState {
  name: string | null;
  pathAndQuery: string | null;
  isLoading: boolean;
  error: unknown;
  isHidden: boolean;
}

const initialState: CurrentSidebarState = {
  name: null,
  pathAndQuery: '',
  isLoading: false,
  error: null,
  isHidden: false,
};

const currentSidebarSlice = createSlice({
  name: 'currentSidebar',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeLocation, (state, action) => {
        const hashUrl = extractHash(action.payload.url);
        const name = getOverlayName(hashUrl) ?? null;
        if (isSidebarApp(hashUrl)) {
          state.name = name;
          state.pathAndQuery = hashUrl.replace(/^#/, '');
          state.isHidden = isSidebarHidden(hashUrl);
        } else {
          state.name = null;
          state.pathAndQuery = null;
          state.isHidden = false;
        }
      })
      .addCase(openSidebar, (state, action) => {
        const pathAndQuery = extractPathAndQuery(action.payload.url) ?? '';
        state.name = getAppName(pathAndQuery) ?? null;
        state.pathAndQuery = pathAndQuery;
        state.isHidden = false;
      })
      .addCase(closeSidebar, (state) => {
        state.name = null;
      })
      .addCase(setLoadingSidebar, (state, action) => {
        state.isLoading = action.payload;
      });
  },
});

export const currentSidebarReducer = currentSidebarSlice.reducer;
